import React from 'react'
import { Card, CardContent } from '@mui/material'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import { Height } from '@mui/icons-material'

export const RowBarComponent = ({ title, hotels, icon, color }) => {
    const seriesData = [
        {
            name: '',
            // random data
            data: hotels?.map((el) => parseInt(el?.dpe?.consumption?.value)),
            color: color,
        },
    ]

    const options = {
        chart: {
            type: 'bar',
            height: 130,
        },
        title: {
            // no title
            text: '',
        },
        xAxis: {
            categories: hotels?.map((el) => el.name),
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
            labels: {
                enabled: false, // Hide x-axis labels
            },
        },
        legend: {
            reversed: true,
            display: false,
            enabled: false,
        },
        exporting: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                borderRadius: '50%',
                dataLabels: {
                    enabled: true,
                },
                pointPadding: 0,
            },
            column: {
                pointPadding: 0,
                borderWidth: 0,
            },
            series: {
                pointWidth: 15,
                pointPadding: 0,
                groupPadding: 0.1,
            },
        },
        series: seriesData,
    }

    return (
        <Card>
            <CardContent style={{ position: 'relative' }}>
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'flex-start',
                    }}
                >
                    {icon}
                    <div style={{ marginLeft: 10, fontWeight: 'bold' }}>{title}</div>
                </div>
                <br />
                <HighchartsReact highcharts={Highcharts} options={options} />
            </CardContent>
        </Card>
    )
}
